var DOC = document;

var CORE = {

	className: 'brtn-loading',

	element: null,

	loadElement: function () {

		if (CORE.element !== null) {
			return;
		}
		CORE.element = DOC.createElement('div');
		CORE.element.className = CORE.className;
		CORE.element.innerHTML = '<div class="' + CORE.className + '__loader">Chargement</div>';

	},

	show: function () {
		var loading = DOC.getElementsByClassName(CORE.className);;

		CORE.loadElement();

		if (typeof loading === 'object' && loading != null && loading.length) {
			return;
		}
		DOC.body.appendChild(CORE.element);

	},

	hide: function () {
		var loading = DOC.getElementsByClassName(CORE.className);;

		CORE.loadElement();

		if (typeof loading !== 'object' || loading == null || !loading.length) {
			return;
		}
		DOC.body.removeChild(CORE.element);

	}

};

export default {
	show: CORE.show,
	hide: CORE.hide
};